export const themeColors = {
  info: '#1c7cd5',
  primary: '#0c4497',
  secondary: '#00b0b9',
  darkSecondary: '#00676d',
  subtitle: '#333840',
  skyBlue: '#a7ddf6',
  redMiddle: '#f0a79e',
  redDark: '#a5110c',
  grayBlue: {
    200: '#afbacc',
  },
  gray: {
    600: '#6c757d',
    500: '#adb5bd',
    400: '#ced4da',
  },

  // Colors outside of theme colors. Only dedicated to custom chart colors
  charts: {
    beige: '#aa8641',
    beigeLight: '#fcf2cc',
    gray: '#474747',
    blueLight: '#bddefc',
    aquaLight: '#dffafc',
    aquaDark: '#65AA93',
  },
};
